import React from 'react';
import { ListResultsProps } from 'app/area/experience-transfer/operations/types-store';
import { ListItem } from './list-item';
import styles from './list-results.scss';

export const ListResults: React.FC<ListResultsProps> = (props) => {
  const { listItems, updating, translation, updateOperations } = props;
  return listItems?.length > 0
    ? <div className={styles.listResults}>
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.id}
          item={listItem}
          listItems={listItems}
          updating={updating}
          updateOperations={updateOperations}
          translation={translation} />;
      })}
    </div>
    : null;
};
